import { FunctionComponent, useCallback, useRef } from "react";
import { useHistory } from "react-router-dom";
import { ElasticMovie, ElasticMovieType } from "../../../../modules/graphql/api.generated";
import { FocusableComponentLayout, FocusContext, useFocusable } from "../../../../modules/spatialNavigation";
import MovieCard from "../../../shared/movieCard/MovieCard";
import * as styles from "./styles.module.scss";
interface IProps {
  data: ElasticMovie[];
  itemPerRow?: number;
}
const ProgramRowComponent: FunctionComponent<IProps> = (props) => {
  const scrollingRef = useRef<any>(null);
  const history = useHistory();
  const { ref, focusKey, focused } = useFocusable({
    focusBoundaryDirections: ["left"],
    autoRestoreFocus: true,
    isFocusBoundary: true,
  });
  const onAssetFocus = useCallback(
    (l: FocusableComponentLayout, index: number) => {
      scrollingRef.current.style.transform = `translateX(${index * (l.width + 8)}px)`;
      scrollingRef.current.style["-webkit-transform"] = `translateX(${index * (l.width + 8)}px)`;
    },
    [scrollingRef],
  );

  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref} className={styles.rowContainer}>
        <div className={styles.scrollingContainer + " " + styles.rowBox} ref={scrollingRef}>
          {props.data &&
            props.data.map((item, index) => (
              <MovieCard
                countPerRow={props.itemPerRow}
                key={`category-movie-card-${index}`}
                imagePath={item.landscapeImagePath}
                link={`${item.type === ElasticMovieType.Episode ? "/w/" : "/p/"}${item.uid}`}
                isExclusive={item?.isExclusive}
                index={index}
                title={
                  item.type != ElasticMovieType.Episode
                    ? ""
                    : item.title +
                      " " +
                      (item.seasonTitle != item.programTitle ? item.seasonTitle : "") +
                      " سریال " +
                      item.programTitle
                }
                focusKey={"movie" + "-" + item.id}
                onEnterPress={() => {
                  history.push(`${item.type === ElasticMovieType.Episode ? "/w/" : "/p/"}${item.uid}`);
                }}
                onClick={() => {
                  history.push(`${item.type === ElasticMovieType.Episode ? "/w/" : "/p/"}${item.uid}`);
                }}
                onFocus={(l) => {
                  onAssetFocus(l, index);
                }}
              />
            ))}
        </div>
      </div>
    </FocusContext.Provider>
  );
};
export default ProgramRowComponent;
